import { useCallback } from 'react';
import { useUser } from 'contexts';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLastReceiveDaybook } from '../redux/actions/receiveInventory';
import moment from 'moment';

const useReceiveLastDaybook = () => {
   const [selectedDaybookId, setSelectedDaybookId] = useState(null);
   const { user } = useUser();
   const dispatch = useDispatch();
   const lastDaybook = useSelector((state) => state.receiveInventory?.lastReceiveDaybook);

   const getLastDaybook = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         const fromDate = localStorage.getItem('selectedFy_start_date');
         const toDate = localStorage.getItem('selectedFy_end_date');

         const params = {
            companyId: user.loginhistory.companyId,
            fromDate: moment(fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            toDate: moment(toDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            ...(selectedDaybookId && { daybookId: selectedDaybookId }),
         };
         await dispatch(getLastReceiveDaybook(params));
      }
   }, [dispatch, selectedDaybookId, user]);

   useEffect(() => {
      getLastDaybook();
   }, [getLastDaybook]);

   return { lastDaybook, setSelectedDaybookId };
};

export default useReceiveLastDaybook;
